import Loadable from "@loadable/component"

export const SimonSpriteDemo = Loadable(() => import("./castletypia/simon-sprite-demo.js"))

